@if (showTitle && !showIcon) {
  <div class="modal-header">
    <h5 class="modal-title" [ngClass]="titleClass">
      {{
        titleLabel || (type == PopupType.success ? 'common.done' : 'common.information') | translate
      }}
    </h5>
    <button type="button" class="close" aria-label="Close" (click)="cancel()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
}
<div class="modal-body">
  @if (showIcon) {
    <div class="text-center mb-5">
      <img class="icon" alt="Popup Icon" [src]="iconUrl" />
    </div>
  }
  @if (showTitle && showIcon) {
    <div class="text-primary font-weight-extrabold title" [ngClass]="titleClass">
      {{
        titleLabel || (type == PopupType.success ? 'common.done' : 'common.information') | translate
      }}
    </div>
  }
  <div class="message" [innerHTML]="message | translate"></div>
  <div class="buttons">
    @if (type != PopupType.duplicate) {
      <button
        type="button"
        class="btn btn-primary ok"
        aria-label="OK"
        (click)="ok()"
        [ngClass]="okClass"
      >
        {{ okLabel || 'common.ok' | translate }}
      </button>
    }
    @if (type == PopupType.duplicate) {
      <button
        type="button"
        class="btn btn-primary ok"
        aria-label="Replace"
        (click)="replace()"
        [ngClass]="replaceClass"
      >
        {{ replaceLabel || 'common.replaceExistingFile' | translate }}
      </button>
    }
    @if (type == PopupType.duplicate) {
      <button
        type="button"
        class="btn btn-primary ok"
        aria-label="Keep"
        (click)="keep()"
        [ngClass]="keepClass"
      >
        {{ keepLabel || 'common.keepBothFiles' | translate }}
      </button>
    }
    @if (
      type == PopupType.confirm ||
      type == PopupType.duplicate ||
      (type == PopupType.success && cancelLabel)
    ) {
      <button
        type="button"
        class="btn btn cancel"
        aria-label="Cancel"
        (click)="cancel()"
        [ngClass]="cancelClass"
      >
        {{ cancelLabel || 'common.cancel' | translate }}
      </button>
    }
  </div>
</div>
